module.exports = __webpack_public_path__ + "img/11.3ff72fa8.png";